import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import SectionTopOfTable from '../../general/general-component/section-top-of-table/SectionTopOfTable';
import { AbstructVar } from '../../general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../general/general-component/abstruct-component/AbstructLang';
import { useSelectorCustom } from '../../general/general-component/abstruct-component/useSelectorCustom'
import '../creative-work-requests-page/CreativeWorkRequests.css';
import './QuestionForm.css';
import { loadCheckEvaluationByReader, loadEvaluationType } from '../../../store/Actions/ActionEvaluationType'
import { VariableCreativeWorkEvaluation } from './VariableCreativeWorkEvaluation';
import { postEvaluation } from '../../../store/Actions/ActionEvaluation';
import EvaluationCompleted from './EvaluationCompleted';
import moment from 'moment';
import { UsePermissions, hasPermissions } from '../../general/general-component/abstruct-component/UsePermissions';
import CheckPermissions from '../../general/general-component/check-permissions';

function ReaderEvaluation() {
    const { permissionss, loadingMainPermission } = UsePermissions();
    const project_requests = hasPermissions([{ name: "project-requests" }], permissionss)
    const { dispatch, langLocal, navigate } = AbstructVar();
    const { translate } = AbstructLang();
    const location = useLocation();
    const arr = location.state.arr;
    let { id } = useParams()
    const [notes, setnotes] = useState('');
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [selectedOption, setSelectedOption] = useState('');
    const [evaluationData, setEvaluationData] = useState([]);
    const { evaluation, loadingevaluation } = useSelectorCustom();
    const [evaluationStatus, setEvaluationStatus] = useState(true);
    const [evaluationStatusType, setEvaluationStatusType] = useState('finishTime');

    useEffect(() => {
        console.log(id)
        loadCheckEvaluationByReader(setEvaluationStatus, setEvaluationStatusType, id)();
    }, []);

    useEffect(() => {
        dispatch(loadEvaluationType(navigate))
    }, []);

    const options = [
        {
            id: 1,
            name: 'unacceptable',
            degree: 2,
        },
        {
            id: 2,
            name: 'poor',
            degree: 4,
        },
        {
            id: 3,
            name: 'satisfactory',
            degree: 6,
        },
        {
            id: 4,
            name: 'good',
            degree: 8,
        },
        {
            id: 5,
            name: 'excellent',
            degree: 10,
        },
    ];

    const handleOptionClick = (option) => {
        const updatedData = [...evaluationData];
        updatedData[currentQuestion] = {
            creative_evaluation_type_id: evaluation[currentQuestion].id,
            degree: option.degree,
        };
        setEvaluationData(updatedData);
        setSelectedOption(option.name);
    };

    const handleNextQuestion = () => {
        if (currentQuestion < evaluation.length - 1 && evaluationData[currentQuestion]?.degree !== undefined) {
            setSelectedOption('');
            setCurrentQuestion(currentQuestion + 1);
        }
    };

    const handlePreviousQuestion = () => {
        if (currentQuestion != 0) {
            setSelectedOption('');
            setCurrentQuestion(currentQuestion - 1);
        }
    };

    const { setLoad } = VariableCreativeWorkEvaluation();

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(postEvaluation(arr.id, notes, evaluationData, setLoad, setEvaluationStatus, setEvaluationStatusType));
    };

    return (
        <>
            <CheckPermissions array={project_requests} loadingMainPermission={loadingMainPermission} >
                <main>
                    <div className="div_table margin_main shadow_main" dir={langLocal === 'ar' ? "rtl" : "ltr"} >
                        <SectionTopOfTable langLocal={langLocal} title={translate('summaries_details')} />
                        <div className='Summaries_Details' >

                            <div className='Summaries_Details_left' >

                                <div className='Work_Overview_left' >
                                    <h4>{translate('script-overview')}</h4>
                                    <div className='Work_Overview' >
                                        <div className='one_Work_Overview' >
                                            <p className='title_Work_Overview'>{translate('reader_name')}</p>
                                            <p className='p_Work_Overview'>{arr.visitor.first_name} {arr.visitor.last_name}</p>
                                        </div>
                                        <div className='one_Work_Overview' >
                                            <p className='title_Work_Overview'>{translate('work_title')}</p>
                                            <p className='p_Work_Overview'>{arr.title}</p>
                                        </div>
                                        <div className='one_Work_Overview' >
                                            <p className='title_Work_Overview'>{translate('due_date')}</p>
                                            <p className='p_Work_Overview'>{moment(arr.created_at).format("YYYY-MM-DD")}</p>
                                        </div>
                                        <div className='one_Work_Overview' >
                                            <p className='title_Work_Overview'>{translate('source')}</p>
                                            <p className='p_Work_Overview'>{arr.source}</p>
                                        </div>
                                        <div className='one_Work_Overview' >
                                            <p className='title_Work_Overview'>{translate('status')}</p>
                                            <p className='p_Work_Overview'>{arr.status}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="Work_Overview_left">
                                    {

                                        evaluationStatus ? (
                                            loadingevaluation === false && (
                                                <div>
                                                    <h4>{translate('evaluations_details')}</h4>
                                                    <div className="question-section">
                                                        <h2>Question {currentQuestion + 1}</h2>
                                                        <p className="question-name">{evaluation[currentQuestion].name}</p>
                                                        <div className="options">
                                                            {
                                                                options.map((option, index) => (
                                                                    <div
                                                                        key={index}
                                                                        className={`option ${evaluationData[currentQuestion]?.degree === option.degree ? 'selected' : ''}`}
                                                                        onClick={() => handleOptionClick(option)}
                                                                    >
                                                                        <span></span>
                                                                        {option.name}
                                                                        <span></span>
                                                                        <span></span>
                                                                        <span></span>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                        {
                                                            currentQuestion === evaluation.length - 1 && (
                                                                <div className='evaluation_notes' >
                                                                    <textarea placeholder='Your Notes ...' onChange={(e) => setnotes(e.target.value)} />
                                                                </div>
                                                            )
                                                        }
                                                        <button className='question-btn' onClick={handlePreviousQuestion}>Previous</button>
                                                        {currentQuestion === evaluation.length - 1 ? (
                                                            <button className='question-btn' style={{ background: 'green' }} onClick={handleSubmit}>Submit</button>
                                                        ) : (
                                                            <button className='question-btn' onClick={handleNextQuestion}>Next</button>
                                                        )}
                                                    </div>
                                                </div>
                                            )) : <EvaluationCompleted translate={translate} type={evaluationStatusType} />

                                    }
                                </div>

                            </div>

                            <div className='Summaries_Details_right'>
                                <h4>{translate('summaries_attachments_files')}</h4>
                                {
                                    arr.summaries.map((ss) => {
                                        console.log(ss.file_path);
                                        return (
                                            <div className='one_files' >
                                                <div>
                                                    <div className={`episode_number ${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} `} >{ss.episode_number}</div>
                                                    <p>{ss.description}</p>
                                                </div>

                                                <a href={`${ss.file_path}`} target="_blank" download><i className='fa fa-download' ></i></a>
                                            </div>
                                        )
                                    })
                                }
                            </div>

                        </div>
                    </div>
                </main >
            </CheckPermissions>


        </>
    );
}

export default ReaderEvaluation;
